const PhoneIcon = (): JSX.Element => (
  <svg
    className="app"
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.435929 0.576804L2.87338 0.0143156C3.13822 -0.0466206 3.41009 0.0916578 3.5179 0.34009L4.64287 2.96503C4.74131 3.19472 4.67569 3.46424 4.48116 3.62127L3.06088 4.78375C3.90461 6.58137 5.3788 8.07664 7.21392 8.93678L8.37639 7.5165C8.53576 7.32197 8.80295 7.25635 9.03263 7.35479L11.6576 8.47976C11.9084 8.58992 12.0466 8.86178 11.9857 9.12662L11.4232 11.5641C11.3646 11.8172 11.1396 12 10.8748 12C4.87256 12 0 7.13682 0 1.12523C0 0.862735 0.180466 0.635396 0.435929 0.576804Z" />
  </svg>
);

export default PhoneIcon;
